module.exports = __webpack_public_path__ + "img/apple-store-en.6df95a26.png";